import { TOptions } from 'i18next';
import { merge } from 'lodash';
import { defaultTranslationKeyOptions } from './translate-hoc.constants';
import { DELIMITER } from 'constants/platform';
import { MODIFIED_TRANSLATION_KEYS_OPTIONS } from './translate-hoc.constants';

export const addDefaultTextKeysOptions = (translationOptions: TOptions<object> = {}) => {
    return merge(translationOptions, defaultTranslationKeyOptions);
};

export const modifyTranslationKeysOptions = ([name, value]: [string, string]): string[] => {
    const modifiedList = MODIFIED_TRANSLATION_KEYS_OPTIONS[name];

    if (modifiedList) {
        const valuesList = value.split(DELIMITER);
        const modifiedValue = valuesList.map(val => modifiedList[val] ?? val).join(DELIMITER);
        return [name, modifiedValue];
    }
    return [name, value];
};
